// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-outline-primary {
  color: #83a4cf;
  border-color: #83a4cf;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  /* background-color: #83A4CF; */
  color: #fff;
}

.bg-white {
  background-color: #fff;
}

.mainDiv {
  /* margin-top:80px; */
}

.widget_bus {
  /* background: #CDDAEA; */
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
  border-radius: 5px;
}

.widget_Bus {
  background: #cddaea;
}

.widgetIcon img {
  width: 50px;
  height: 50px;
}

.widgetIcon-32 img {
  width: 32px;
  height: 32px;
}

.titlebg_bus {
  font-size: 1em;
  color: #0e3157;
  font-weight: 600;
  /* margin-bottom: 10px; */
  text-align: center;
  background: #e0e0e0;
  border-radius: 5px 5px 0 0;
  /* margin-top: -12px;
    margin-left: -10px;
    margin-right: -10px; */
}

/* .chartbox {
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 5px 10px;
    color: #353535;
    min-height: 255px;
    border-radius: 5px;
} */

.chartHGT_Bus {
  padding: 10px;
}

h5,
.h5 {
  font-size: 1.1rem !important;
}

p {
  line-height: 1rem !important;
}

small,
.small {
  font-size: 80% !important;
}

table tr td {
  font-size: 0.8em;
}

.accordion-button_bus {
  font-size: 0.5em;
  background-color: #fff;
}

.accordion-button_bus:focus {
  /* background-color: rgb(255, 255, 255, 1) !important; */
  background-color: #fff !important;
  box-shadow: inset 0 -1px 0 #fff !important;
  /* box-shadow: inset 0 -1px 0 rgb(255, 255, 255, 1) !important; */
}

.accordion-button_bus:not(.collapsed) {
  /* background-color:#e0e0e0; */
  background-color: rgb(179, 177, 177) !important;
  color: #222;
}

/* .filterForm>.form-label {
    font-size: 0.825em;
} */

/* .form-label {
    font-size: 0.825em;
} */

.Headfont {
  font-size: 1.8rem;
}

.dropdown-menu[data-bs-popper] {
  right: 0 !important;
  left: auto;
}

/******************** 17042023 *********************/
.nav-link {
  font-size: 0.85em !important;
}

.nav-link {
  font-size: 0.85em !important;
  color: #000 !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  /* color: var(--bs-navbar-active-color); */
  color: #ffffff !important;
  background-color: #83a4cf;
  border-radius: 20px;
  padding: 5px 10px;
  text-align: center;
}

.bus_nav_icon {
  font-size: 14px;
}

/* .btn-primary{
	background-color: #83A4CF !important;
    border-color: #83A4CF !important;
} */
.txtColor,
p {
  color: #0e3157;
}

.mainDiv_bus {
  margin-top: 15px;
}

body {
  /* background-color: #F2F3FC !important; */
}

.cardBox > .card {
}

.cardBox > .card > .card-body {
  padding: 5px !important;
}

/***************************** PageTwo *******************************/
.bt-graph {
  border-right: solid 1px #b5b5b5;
}

.headBG {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #83a4cf;
  border-radius: 5px;
}

/* media queries start here */

@media (min-width: 836px) {
  .navbar-expand-sm {
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
  }
}

@media screen and (max-width: 740px) {
  .titlebg {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 720px) {
  .mainDiv {
    /* margin-top:124px; */
  }
}

@media screen and (max-width: 480px) {
  .mainDiv {
    /* margin-top:155px; */
  }
}

@media screen and (max-width: 480px) {
  .topHeader h2 {
    font-size: 22px;
    padding-right: 3rem;
  }

  .titlebg {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 320px) {
  .topHeader h2 {
    font-size: 16px;
    padding-right: 0rem;
  }
}

/*---------------------------*/

body {
  margin: 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  width: 100%;
  height: 100%;
  /* background-color: #F5F5F5 !important; */
}

.bg-theme {
  background: #358696 !important;
  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);
}

/* .headFont{ */
/* font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff; */
/* } */
.nav-link {
  font-size: 0.85em !important;
  color: #000 !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  /* color: var(--bs-navbar-active-color); */
  color: #ffffff !important;
  background-color: #83a4cf;
  border-radius: 20px;
  padding: 5px 10px;
  text-align: center;
}

.bus_nav_icon {
  font-size: 14px;
}

/********* Landing 2 Starts ********/
.dashboard_card {
  font-size: 1.1em;
  color: #000;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: 0.5s;
  background: #fff;
  border: solid 1px #c3c3c3;
  box-shadow: 1px 1px 25px #33333320;
  padding: 45px 15px 45px 15px;
  margin-top: 20px;
  width: 100%;
}

.dashboard_card img {
  width: 50px;
}

.dashboard_card span {
  display: block;
  padding-top: 15px;
  font-weight: 600;
  line-height: 25px;
}

.dashboard_card:hover {
  box-shadow: 1px 1px 25px #999;
}

/********* Media Queries Starts ********/

@media (min-width: 836px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 991px) {
}

@media screen and (max-width: 769px) {
}

@media screen and (max-width: 420px) {
}

/****************CSS Chnaged*********************/
.titlebg strong {
  position: absolute;
  top: 3px;
  right: 8px;
}

.titlebg_ev strong {
  position: absolute;
  top: 5px;
  right: 23px;
}

.text-fit {
  padding: 9px;
}

.FilterDiv_bus {
  background: #fff;
}

.chartbox_bus {
  padding: 0px;
}

.FilterDiv_bus {
  background-color: #f8f9fa !important;
  /* margin-bottom: -16px !important; */
}

.btn_bus {
  background-color: #83a4cf !important;
}

.filter_bus_icon {
  background: #83a4cf !important;
}

.card_bus {
  border: 1px solid #83a4cf;
}

.back_chng {
  background: #e0e0e0;
}

.busflt {
  border: 1px solid #a5b0a9 !important;
  border-radius: 6px;
}

.busdrpg1 {
  background-color: #f2f3fc !important;
  /* margin: -3px; */
}

.bus_tkps {
  padding: 0px 12px;
}

.titlebg .tlbg_bus {
  right: 30px !important;
}

.bus_bg_c {
  /* background-color: #F5F5F5; */
}

/*******************CSS ENd***********************/

/* #F5F5F5 */
/* #F2F3FC */
/* added code for filters */
.bus_filtr_btn .btn-primary {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}
.bus_filtr_btn .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}
.form-label_bus {
  /* color: #83a4cf !important; */
  background: transparent;
  padding: 0px !important;
  text-align: left;
  margin-bottom: 0px !important;
  color: #83a4cf !important;
  font-weight: 600;
  display: block;
}
.select_col_title_bus {
  background: transparent;
  padding: 0px !important;
  text-align: left;
  margin-bottom: 0px !important;
  color: #83a4cf !important;
  font-weight: 600;
  display: block;
}
.row.equal-cols {
  display: flex;
  flex-wrap: wrap;
}

.row.equal-cols:before,
.row.equal-cols:after {
  display: block;
}

.row.equal-cols > [class*="col-"] {
  display: flex;
  flex-direction: column;
}

.row.equal-cols > [class*="col-"] > * {
  flex: 1 1 auto;
}
.bus .form-check-input:checked {
  background-color: #83a4cf;
  border-color: #83a4cf96;
}
.filter_bus_icon_f .btn:hover {
  color: #fff !important;
  background-color: #83a4cf96 !important;
  border-color: #83a4cf96 !important;
}
.titlebg_bus1 {
  font-size: 1em;
  color: #0e3157;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  background: #fff;
  border-radius: 5px 5px 0 0;
  margin-top: -12px;
  margin-left: -10px;
  margin-right: -10px !important;
}
.monthclass {
  float: right;
}
.row {
  /* margin-right: -14px; */
}
dl dt.red_bus {
  background: #5579a6;
}

dl dt.yellow_bus {
  background: #83a4cf;
}

.bus_filtr_btn .rca_btn_bus {
  background-color: #ffa650 !important;
}

.bus_filtr_btn .rca_btn_bus:hover {
  background-color: #fcb877 !important;
  border-color: #fcb877 !important;
}

.btn_drive {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}

.btn_drive:hover {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}

.btn_drive:focus,
.btn_drive:focus-visible,
.btn_drive:focus-within,
.btn_drive:hover,
.btn_drive:visited,
.btn_drive:active,
.btn_drive:target {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.react-datepicker-wrapper {
  /* position: relative; */
  margin-left: -9px;
  /* visibility: hidden !important; */
}

.drive_last {
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Driveanalysis_Bus/Driveanalysis_Bus.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B;;0BAEwB;AAC1B;;AAEA;;;;;;;GAOG;;AAEH;EACE,aAAa;AACf;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;EACxD,iCAAiC;EACjC,0CAA0C;EAC1C,iEAAiE;AACnE;;AAEA;EACE,8BAA8B;EAC9B,+CAA+C;EAC/C,WAAW;AACb;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;GAGG;AACH;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;AACA;;AAEA;EACE,uBAAuB;AACzB;;AAEA,sEAAsE;AACtE;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;;AAE7B;EACE;IACE,4BAA4B;IAC5B,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,8BAA8B;;AAE9B;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,eAAe;AACf,uEAAuE;AACvE,MAAM;AACN;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wCAAwC;;AAExC;EACE;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kDAAkD;;AAElD,YAAY;AACZ,YAAY;AACZ,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;;EAOE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EAGE,aAAa;EAGb,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EAGE,aAAa;EAGb,sBAAsB;AACxB;;AAEA;EAGE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".btn-outline-primary {\r\n  color: #83a4cf;\r\n  border-color: #83a4cf;\r\n}\r\n\r\n.btn-outline-primary:hover,\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary:visited,\r\n.btn-outline-primary:active,\r\n.btn-check:checked + .btn,\r\n.btn.active,\r\n.btn.show,\r\n.btn:first-child:active,\r\n:not(.btn-check) + .btn:active {\r\n  /* background-color: #83A4CF; */\r\n  color: #fff;\r\n}\r\n\r\n.bg-white {\r\n  background-color: #fff;\r\n}\r\n\r\n.mainDiv {\r\n  /* margin-top:80px; */\r\n}\r\n\r\n.widget_bus {\r\n  /* background: #CDDAEA; */\r\n  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\r\n  border-radius: 5px;\r\n}\r\n\r\n.widget_Bus {\r\n  background: #cddaea;\r\n}\r\n\r\n.widgetIcon img {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.widgetIcon-32 img {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.titlebg_bus {\r\n  font-size: 1em;\r\n  color: #0e3157;\r\n  font-weight: 600;\r\n  /* margin-bottom: 10px; */\r\n  text-align: center;\r\n  background: #e0e0e0;\r\n  border-radius: 5px 5px 0 0;\r\n  /* margin-top: -12px;\r\n    margin-left: -10px;\r\n    margin-right: -10px; */\r\n}\r\n\r\n/* .chartbox {\r\n    background: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 5px 10px;\r\n    color: #353535;\r\n    min-height: 255px;\r\n    border-radius: 5px;\r\n} */\r\n\r\n.chartHGT_Bus {\r\n  padding: 10px;\r\n}\r\n\r\nh5,\r\n.h5 {\r\n  font-size: 1.1rem !important;\r\n}\r\n\r\np {\r\n  line-height: 1rem !important;\r\n}\r\n\r\nsmall,\r\n.small {\r\n  font-size: 80% !important;\r\n}\r\n\r\ntable tr td {\r\n  font-size: 0.8em;\r\n}\r\n\r\n.accordion-button_bus {\r\n  font-size: 0.5em;\r\n  background-color: #fff;\r\n}\r\n\r\n.accordion-button_bus:focus {\r\n  /* background-color: rgb(255, 255, 255, 1) !important; */\r\n  background-color: #fff !important;\r\n  box-shadow: inset 0 -1px 0 #fff !important;\r\n  /* box-shadow: inset 0 -1px 0 rgb(255, 255, 255, 1) !important; */\r\n}\r\n\r\n.accordion-button_bus:not(.collapsed) {\r\n  /* background-color:#e0e0e0; */\r\n  background-color: rgb(179, 177, 177) !important;\r\n  color: #222;\r\n}\r\n\r\n/* .filterForm>.form-label {\r\n    font-size: 0.825em;\r\n} */\r\n\r\n/* .form-label {\r\n    font-size: 0.825em;\r\n} */\r\n\r\n.Headfont {\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.dropdown-menu[data-bs-popper] {\r\n  right: 0 !important;\r\n  left: auto;\r\n}\r\n\r\n/******************** 17042023 *********************/\r\n.nav-link {\r\n  font-size: 0.85em !important;\r\n}\r\n\r\n.nav-link {\r\n  font-size: 0.85em !important;\r\n  color: #000 !important;\r\n}\r\n\r\n.navbar-nav .nav-link.active,\r\n.navbar-nav .show > .nav-link {\r\n  /* color: var(--bs-navbar-active-color); */\r\n  color: #ffffff !important;\r\n  background-color: #83a4cf;\r\n  border-radius: 20px;\r\n  padding: 5px 10px;\r\n  text-align: center;\r\n}\r\n\r\n.bus_nav_icon {\r\n  font-size: 14px;\r\n}\r\n\r\n/* .btn-primary{\r\n\tbackground-color: #83A4CF !important;\r\n    border-color: #83A4CF !important;\r\n} */\r\n.txtColor,\r\np {\r\n  color: #0e3157;\r\n}\r\n\r\n.mainDiv_bus {\r\n  margin-top: 15px;\r\n}\r\n\r\nbody {\r\n  /* background-color: #F2F3FC !important; */\r\n}\r\n\r\n.cardBox > .card {\r\n}\r\n\r\n.cardBox > .card > .card-body {\r\n  padding: 5px !important;\r\n}\r\n\r\n/***************************** PageTwo *******************************/\r\n.bt-graph {\r\n  border-right: solid 1px #b5b5b5;\r\n}\r\n\r\n.headBG {\r\n  box-sizing: border-box;\r\n  background: #ffffff;\r\n  border: 1px solid #83a4cf;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* media queries start here */\r\n\r\n@media (min-width: 836px) {\r\n  .navbar-expand-sm {\r\n    flex-wrap: nowrap !important;\r\n    justify-content: flex-start !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 740px) {\r\n  .titlebg {\r\n    font-size: 0.9em;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 720px) {\r\n  .mainDiv {\r\n    /* margin-top:124px; */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .mainDiv {\r\n    /* margin-top:155px; */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .topHeader h2 {\r\n    font-size: 22px;\r\n    padding-right: 3rem;\r\n  }\r\n\r\n  .titlebg {\r\n    font-size: 0.9em;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 320px) {\r\n  .topHeader h2 {\r\n    font-size: 16px;\r\n    padding-right: 0rem;\r\n  }\r\n}\r\n\r\n/*---------------------------*/\r\n\r\nbody {\r\n  margin: 0px;\r\n  padding: 0px;\r\n  font-family: \"Open Sans\", sans-serif;\r\n  width: 100%;\r\n  height: 100%;\r\n  /* background-color: #F5F5F5 !important; */\r\n}\r\n\r\n.bg-theme {\r\n  background: #358696 !important;\r\n  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);\r\n}\r\n\r\n/* .headFont{ */\r\n/* font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff; */\r\n/* } */\r\n.nav-link {\r\n  font-size: 0.85em !important;\r\n  color: #000 !important;\r\n}\r\n\r\n.navbar-nav .nav-link.active,\r\n.navbar-nav .show > .nav-link {\r\n  /* color: var(--bs-navbar-active-color); */\r\n  color: #ffffff !important;\r\n  background-color: #83a4cf;\r\n  border-radius: 20px;\r\n  padding: 5px 10px;\r\n  text-align: center;\r\n}\r\n\r\n.bus_nav_icon {\r\n  font-size: 14px;\r\n}\r\n\r\n/********* Landing 2 Starts ********/\r\n.dashboard_card {\r\n  font-size: 1.1em;\r\n  color: #000;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: 0.5s;\r\n  background: #fff;\r\n  border: solid 1px #c3c3c3;\r\n  box-shadow: 1px 1px 25px #33333320;\r\n  padding: 45px 15px 45px 15px;\r\n  margin-top: 20px;\r\n  width: 100%;\r\n}\r\n\r\n.dashboard_card img {\r\n  width: 50px;\r\n}\r\n\r\n.dashboard_card span {\r\n  display: block;\r\n  padding-top: 15px;\r\n  font-weight: 600;\r\n  line-height: 25px;\r\n}\r\n\r\n.dashboard_card:hover {\r\n  box-shadow: 1px 1px 25px #999;\r\n}\r\n\r\n/********* Media Queries Starts ********/\r\n\r\n@media (min-width: 836px) {\r\n  .navbar-expand-sm {\r\n    flex-wrap: nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n}\r\n\r\n@media screen and (max-width: 769px) {\r\n}\r\n\r\n@media screen and (max-width: 420px) {\r\n}\r\n\r\n/****************CSS Chnaged*********************/\r\n.titlebg strong {\r\n  position: absolute;\r\n  top: 3px;\r\n  right: 8px;\r\n}\r\n\r\n.titlebg_ev strong {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 23px;\r\n}\r\n\r\n.text-fit {\r\n  padding: 9px;\r\n}\r\n\r\n.FilterDiv_bus {\r\n  background: #fff;\r\n}\r\n\r\n.chartbox_bus {\r\n  padding: 0px;\r\n}\r\n\r\n.FilterDiv_bus {\r\n  background-color: #f8f9fa !important;\r\n  /* margin-bottom: -16px !important; */\r\n}\r\n\r\n.btn_bus {\r\n  background-color: #83a4cf !important;\r\n}\r\n\r\n.filter_bus_icon {\r\n  background: #83a4cf !important;\r\n}\r\n\r\n.card_bus {\r\n  border: 1px solid #83a4cf;\r\n}\r\n\r\n.back_chng {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.busflt {\r\n  border: 1px solid #a5b0a9 !important;\r\n  border-radius: 6px;\r\n}\r\n\r\n.busdrpg1 {\r\n  background-color: #f2f3fc !important;\r\n  /* margin: -3px; */\r\n}\r\n\r\n.bus_tkps {\r\n  padding: 0px 12px;\r\n}\r\n\r\n.titlebg .tlbg_bus {\r\n  right: 30px !important;\r\n}\r\n\r\n.bus_bg_c {\r\n  /* background-color: #F5F5F5; */\r\n}\r\n\r\n/*******************CSS ENd***********************/\r\n\r\n/* #F5F5F5 */\r\n/* #F2F3FC */\r\n/* added code for filters */\r\n.bus_filtr_btn .btn-primary {\r\n  background-color: #83a4cf !important;\r\n  border-color: #83a4cf !important;\r\n}\r\n.bus_filtr_btn .btn:focus,\r\n.btn:focus-visible,\r\n.btn:focus-within,\r\n.btn:hover,\r\n.btn:visited,\r\n.btn:active,\r\n.btn:target {\r\n  background-color: #83a4cf !important;\r\n  border-color: #83a4cf !important;\r\n}\r\n.form-label_bus {\r\n  /* color: #83a4cf !important; */\r\n  background: transparent;\r\n  padding: 0px !important;\r\n  text-align: left;\r\n  margin-bottom: 0px !important;\r\n  color: #83a4cf !important;\r\n  font-weight: 600;\r\n  display: block;\r\n}\r\n.select_col_title_bus {\r\n  background: transparent;\r\n  padding: 0px !important;\r\n  text-align: left;\r\n  margin-bottom: 0px !important;\r\n  color: #83a4cf !important;\r\n  font-weight: 600;\r\n  display: block;\r\n}\r\n.row.equal-cols {\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-flex-wrap: wrap;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.row.equal-cols:before,\r\n.row.equal-cols:after {\r\n  display: block;\r\n}\r\n\r\n.row.equal-cols > [class*=\"col-\"] {\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n}\r\n\r\n.row.equal-cols > [class*=\"col-\"] > * {\r\n  -webkit-flex: 1 1 auto;\r\n  -ms-flex: 1 1 auto;\r\n  flex: 1 1 auto;\r\n}\r\n.bus .form-check-input:checked {\r\n  background-color: #83a4cf;\r\n  border-color: #83a4cf96;\r\n}\r\n.filter_bus_icon_f .btn:hover {\r\n  color: #fff !important;\r\n  background-color: #83a4cf96 !important;\r\n  border-color: #83a4cf96 !important;\r\n}\r\n.titlebg_bus1 {\r\n  font-size: 1em;\r\n  color: #0e3157;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n  text-align: center;\r\n  background: #fff;\r\n  border-radius: 5px 5px 0 0;\r\n  margin-top: -12px;\r\n  margin-left: -10px;\r\n  margin-right: -10px !important;\r\n}\r\n.monthclass {\r\n  float: right;\r\n}\r\n.row {\r\n  /* margin-right: -14px; */\r\n}\r\ndl dt.red_bus {\r\n  background: #5579a6;\r\n}\r\n\r\ndl dt.yellow_bus {\r\n  background: #83a4cf;\r\n}\r\n\r\n.bus_filtr_btn .rca_btn_bus {\r\n  background-color: #ffa650 !important;\r\n}\r\n\r\n.bus_filtr_btn .rca_btn_bus:hover {\r\n  background-color: #fcb877 !important;\r\n  border-color: #fcb877 !important;\r\n}\r\n\r\n.btn_drive {\r\n  background-color: #83a4cf !important;\r\n  border-color: #83a4cf !important;\r\n}\r\n\r\n.btn_drive:hover {\r\n  background-color: #83a4cf !important;\r\n  border-color: #83a4cf !important;\r\n}\r\n\r\n.btn_drive:focus,\r\n.btn_drive:focus-visible,\r\n.btn_drive:focus-within,\r\n.btn_drive:hover,\r\n.btn_drive:visited,\r\n.btn_drive:active,\r\n.btn_drive:target {\r\n  background-color: #83a4cf !important;\r\n  border-color: #83a4cf !important;\r\n}\r\n\r\n.visually-hidden {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  border: 0;\r\n}\r\n\r\n.react-datepicker-wrapper {\r\n  /* position: relative; */\r\n  margin-left: -9px;\r\n  /* visibility: hidden !important; */\r\n}\r\n\r\n.drive_last {\r\n  padding: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
